module.exports = __webpack_public_path__ + "static/media/Apple iPhone 5c Blue.6e02f911.png";